import Avatar from "../../assets/icons/img/avatar/avatar.png";
import { Link } from "react-router-dom";
import React, { useState, forwardRef } from "react";
import { useLocation } from "react-router-dom";
import styles from "./sidenav.module.scss";
import Settings from "../../assets/icons/svg/settings.svg?react";
import Business from "../../assets/icons/svg/business.svg?react";
import Product from "../../assets/icons/svg/product.svg?react";
import Agency from "../../assets/icons/svg/agency.svg?react";
import { TvMinimalPlay, Binoculars, Library } from "lucide-react";

interface SideNavLinkProps {
  text: string;
  icon: React.ReactNode;
  to: string;
  isActive: boolean;
  settings?: boolean;
  onNavigate: () => void;
}

interface SideNavProps {
  user?: any;
  isSideNavClose: boolean;
}
//nav-item-transition

const SideNavLink: React.FC<SideNavLinkProps> = ({
  text,
  icon,
  to,
  isActive,
  settings,
  onNavigate,
}) => (
  <li
    className={`nav-item d-flex w-100 rounded py-2 justify-content-stretch ${
      settings ? "px-0" : "px-4 py-1"
    }`}
    style={{ overflow: "hidden" }}
  >
    <Link
      to={to}
      className={`nav-link px-1 py-1 w-100 ${
        isActive ? "activeLink" : "inactiveLink"
      }`}
      onClick={onNavigate}
    >
      <span className="d-flex align-items-center gap-3">
        <span className="link_icon">{icon}</span>
        <span className={`ml-2 ${isActive ? "activeLink" : "inactiveLink"}`}>
          {text}
        </span>
      </span>
    </Link>
  </li>
);

export const SideNav = forwardRef<HTMLDivElement, SideNavProps>(
  ({ user, isSideNavClose }, ref) => {
    const location = useLocation();
    const [adminDropdownOpen, setAdminDropdownOpen] = useState(false);

    const isAdminActive = [
      "business",
      "product",
      "agencies",
      "organization",
    ].some((path) => location.pathname.includes(path));

    const handleNavigate = () => {
      if (!isSideNavClose) {
        const event = new CustomEvent("closeSideNav");
        window.dispatchEvent(event);
      }
    };

    return (
      <div
        ref={ref}
        className="sidenav-container d-flex flex-column flex-shrink-0 p-1 border-end"
        style={{
          transform: isSideNavClose ? "translateX(-100%)" : "translateX(0)",
        }}
      >
        <div className="bgGrey">
          <Link
            to="#"
            className="d-flex align-items-center text-decoration-none flex-column mt-1 mb-3"
            style={{ width: "100px", margin: "0 auto" }}
          >
            <div className={styles.avatarContainer}>
              <img
                src={Avatar}
                className="img-thumbnail p-0"
                alt="avatar"
                style={{ borderRadius: "50%" }}
              />
            </div>
            <div>
              <div className="text-center fs-5 mt-2 text-primary">
                {user?.name}
              </div>
              <div className="text-center mt-2 text-secondary fs-6">
                {user?.email}
              </div>
            </div>
          </Link>
        </div>
        <ul className="nav nav-pills nav-flush flex-column mb-auto gap-2 justify-content-stretch">
          <SideNavLink
            to="/media"
            text="Content"
            icon={<TvMinimalPlay className="no-fill" />}
            isActive={location.pathname.includes("media")}
            onNavigate={handleNavigate}
          />
          {/* <SideNavLink
          to="/users"
          text="User"
          icon={<Users />}
          isActive={location.pathname.includes('users')}
          onNavigate={handleNavigate}
        /> */}
          <SideNavLink
            to="/drive/video"
            text="Drive"
            icon={<Library className="no-fill" />}
            isActive={location.pathname.startsWith("/drive")}
            onNavigate={handleNavigate}
          />
          <SideNavLink
            to="/discover"
            text="Discover"
            icon={<Binoculars className="no-fill" />}
            isActive={location.pathname.includes("discover")}
            onNavigate={handleNavigate}
          />
          {/* <SideNavLink
          to="/socialconnect"
          text="Social"
          icon={<Social />}
          isActive={location.pathname.includes('social')}
          onNavigate={handleNavigate}
        /> */}
          <li className="nav-item py-2 dropdown justify-content-stretch px-4 py-1">
            <Link
              to="#"
              className={`nav-link px-1 py-1 w-100 dropdown-toggle position-relative mb-2
              ${isAdminActive ? "activeLink" : "inactiveLink"}
              ${adminDropdownOpen ? "open" : ""}
              `}
              role="button"
              onClick={() => setAdminDropdownOpen(!adminDropdownOpen)}
            >
              <span className="d-flex align-items-center gap-2 justify-content-start">
                <span className={isAdminActive ? "link_icon" : "inactiveLink"}>
                  <Settings />
                </span>
                <span className="ml-2" style={{ fontSize: "14px" }}>
                  Admin
                </span>
              </span>
            </Link>
            <ul
              className={`dropdown-menu ${
                adminDropdownOpen ? styles.show : ""
              }`}
            >
              {/* <SideNavLink
              to="/admin/organization"
              text="Organization"
              icon={<Org />}
              isActive={location.pathname.includes('organization')}
              settings={true}
              onNavigate={handleNavigate}
            /> */}
              <SideNavLink
                to="/admin/business"
                text="Business"
                icon={<Business />}
                isActive={location.pathname.includes("business")}
                settings={true}
                onNavigate={handleNavigate}
              />
              <SideNavLink
                to="/admin/product"
                text="Product"
                icon={<Product />}
                isActive={location.pathname.includes("product")}
                settings={true}
                onNavigate={handleNavigate}
              />
              <SideNavLink
                to="/admin/agencies"
                text="Agencies"
                icon={<Agency />}
                isActive={location.pathname.includes("agencies")}
                settings={true}
                onNavigate={handleNavigate}
              />
            </ul>
          </li>
        </ul>
      </div>
    );
  }
);
SideNav.displayName = "SideNav";

export default SideNav;
